const messages = {
  en: {
    message: {
      headline: 'Page of Entry Home.',
    },
  },
};

export default messages;
